import { isEscape, returnFocus } from "./app/utils.js";

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Imports
*/
import './app/navigation';
import './app/footer-animation';
import './app/contact-takeover';

